/// <reference path="../../../dts/declaration.d.ts" />
/// <reference path="../../../dts/interfaces.d.ts" />

import 'component/member-portal';

import 'component.members/add-travel-coordinator.js';
import 'component.members/change-password.js';
import 'component.members/claim-missing-miles.js';
import 'component.members/contact.js';
import 'component.members/add-travel-coordinator.js';
import 'component.members/edit-travel-coordinator.js';
import 'component.members/enrich-vouchers.js';
import 'component.members/extend-miles.js';
import 'component.members/flight-redemption.js';
import 'component.members/forgot-mhnumber.js';
import 'component.members/forgot-password.js';
import 'component.members/golden-redeem-voucher.js';
import 'component.members/golden-your-redeemed-voucher.js';
import 'component.members/header.js';
import 'component.members/menumob.js';
import 'component.members/index.js';
import 'component.members/my-activity.js';
import 'component.members/print-card.js';
import 'component.members/register-success.js';
import 'component.members/register.js';
import 'component.members/statement.js';
import 'component.members/terms-conditions.js';
import 'component.members/transfer-miles.js';
import 'component.members/travel-coordinator.js';
import 'component.members/update-profile.js';
import 'component.members/update-profile-lcp.js';
import 'component.members/travel-pass.js';
import 'component.members/partner-redem-voucher.js';
import 'component.members/add-traveller.js';
import 'component.members/edit-traveller.js';
import 'component.members/login-details.js';
import 'component.members/add-mytraveller.js';
import 'component.members/lcp-add-mytraveller.js';
import 'component.members/gts_ibe.js';
import 'component.members/points-exchange-miles.js';
import 'component.members/claim-missing-miles-lcp.js';
import 'component.members/enrich_catalogue.js';
import 'component.members/my-activity-LCP.js';
import 'component.members/binifinite.js';
import 'component.members/points-exchange-miles-lcp.js';
import 'component.members/lcp-enrich_summary.js';
import 'component.members/lcp-benefit.js';
import 'component.members/lcp-message.js';
import 'component.members/my-activity-new-LCP.js';
import 'component.members/submission-status.js';
import 'component.members/add-lcptraveller.js';
import 'component.members/lcpedit-traveller.js';
import 'component.members/fly-pass-group-container.js';
import 'component.members/online-services-buy.js';
import 'component.members/online-services-elite.js';
import 'component.members/online-services-gift.js';
import 'component.members/online-services-reactivate.js';
import 'component.members/online-services-extend.js';
import 'component.members/online-services-transfer.js';
import 'component.members/statement-lcp.js';
import 'component.members/online-service.js';
import 'component.members/partner-redem-voucher-lounge.js';
import 'component.members/lcp-enrich-card.js';
import 'component.members/gov-travelstimulus.js';
import 'component.members/stimulus-addtraveller.js';
import 'component.members/stimulus-edittraveller.js';
import 'component.members/member-nominee.js';
import 'component.members/enrich-qcvoucher-catalogue.js';
import 'component.members/referral-invite.js';
import 'component.members/enrich-vouchers-redemption.js';
import 'component.members/mhgiftcard-redeem.js';
import 'component.members/points-exchange.js';
import 'component.members/mhvoucher-redemption.js';
import 'component.members/member-family.js';
import 'component.members/member-nominee-mob.js';
import 'component.members/member-family-mob.js';
import 'component.members/save-card.js';
import 'component.members/enrich-newcatalogue.js';
import 'component.members/enrich-spendbenefits.js';
import 'component.members/enrich_cobrand_cards.js';
import 'component.members/cobrand_ibe.js';

